

import reportApi from '@/api/report.js';
import projectApi from "@/api/project.js";

export default {
  name: "weeklyReport",

  data() {
    return {
      loading: false,
      start: "",
      end: "",
      week:"",
      projectList:[],
      cateList: [],
      cateVal: [],
      percentage:"",
      customColors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f7ad3', percentage: 100}
      ],
      formItem: {
        // "project_id":'',
        "description":'',
        "time":'',
        "subClass": ''
      }
    }
  },
  mounted() {
    this.getProjectList()
    this.getCategoryList()
  },
  methods: {
    customColorMethod() {
      if (this.percentage < 30) {
        return '#909399';
      } else if (this.percentage < 70) {
        return '#e6a23c';
      } else {
        return '#67c23a';
      }
    },
    increase() {
      this.percentage += 10;
      if (this.percentage > 100) {
        this.percentage = 100;
      }
    },
    decrease() {
      this.percentage -= 10;
      if (this.percentage < 0) {
        this.percentage = 0;
      }
    },
    newDateWeekHandle() {
      const now = new Date(this.week);
      const nowTime = now.getTime();
      const day = now.getDay();
      const oneDayTime = 24*60*60*1000;

      //const mondayTime = nowTime - (day-1)*oneDayTime;
      const sundayTime = nowTime + (day-2)*oneDayTime;
      const saturdayTime = nowTime + (7-day-1)*oneDayTime;
      this.start = this.$moment(sundayTime).format('YYYY-MM-DD');
      this.end = this.$moment(saturdayTime).format('YYYY-MM-DD');
    },
    getDateWeek() {
      const now = new Date();
      const nowTime = now.getTime();
      const day = now.getDay();
      const oneDayTime = 24*60*60*1000;
      const mondayTime = nowTime - (day-1)*oneDayTime;//默认是周二
      this.week = new Date(mondayTime);
      this.newDateWeekHandle();
    },
    handleChange() {
      console.log(this.cateVal);
    },
    getProjectList() {
      projectApi.getProjects().then(
        res => {
          this.projectList = res.data.data
        }
      )
    },
    getCategoryList() {
      reportApi.getCategory().then(
        res => {
          this.cateList = res.data.data
          this.subClass = res.data.subClass
        }
      )
    },
    submitReport() {
      let payload = this.formItem
      payload['week_start'] = this.start
      payload['week_end'] = this.end
      // payload['project_id'] = this.formItem.project_id
      payload['description'] = this.formItem.description
      payload['percentage'] = this.percentage
      payload['time'] = this.formItem.time
      payload['category'] = this.cateVal[0]
      payload['category2nd'] = this.cateVal[1] ? this.cateVal[1] : null
      payload['category3rd'] = this.cateVal[2] ? this.cateVal[2] : null
      payload['subClass'] = this.formItem.subClass
      reportApi.createReport(payload).then(
      )
      this.handleReset()
    },
    handleReset() {
      this.cateVal = []
      this.formItem.description = null
      this.formItem.subClass = null
      this.formItem.time = null
      this.percentage = null
    },
    dataFilter(node: { text: string; }, val: string) {
      if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
        return true
      }
    },
  },
  created() {
    this.getDateWeek()
  }

};
